import * as React from "react"
import { SFProIcon, SFProIconProps } from "./SFProIcon"

export interface CheckmarkIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * Checkmark icon using SF Pro font symbol (􀁣)
 *
 * This icon represents confirmation, success, or validation status,
 * commonly used to indicate successful pairing or verification.
 *
 * @example
 * ```tsx
 * <CheckmarkIcon />
 * <CheckmarkIcon size={12} weight="bold" className="text-brand-green" />
 * ```
 */
export const CheckmarkIcon = React.forwardRef<HTMLSpanElement, CheckmarkIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀁣" {...props} />
  }
)

CheckmarkIcon.displayName = "CheckmarkIcon"
